module.exports = __webpack_public_path__ + "img/mcp-color.d778fc85.png";